/** Item paint-ready de getOrdersAvailablePage (Core). */
export interface OrderAvailableProviderSnapshot {
  name?: string | null;
}

export interface OrderAvailableFileSnapshot {
  fileNumber?: string | null;
  fileExtend?: string | null;
}

export interface OrderAvailableServiceSnapshot {
  serviceType?: string | null;
}

export interface OrderAvailableLine {
  serviceId?: string | null;
  serviceSnapshot?: OrderAvailableServiceSnapshot | null;
}

export interface OrderAvailableItem {
  orderId: string;
  orderNumber?: string | null;
  orderStatus?: string | null;
  reservationNumber?: string | null;
  reservationStatus?: string | null;
  paymentCondition?: string | null;
  paidAt?: string | null;
  scheduledPaymentDate?: string | null;
  currency?: string | null;
  /** Total a pagar. Incluye la comisión. */
  total?: number | null;
  commissionPercent?: number | null;
  commissionAmount?: number | null;
  providerSnapshot?: OrderAvailableProviderSnapshot | null;
  fileSnapshot?: OrderAvailableFileSnapshot | null;
  lines?: OrderAvailableLine[] | null;
}

export interface GetOrdersAvailableInput {
  limit?: number | null;
  /** Cursor opaco; primera página: null. No parsear. */
  lastKey?: string | null;
}

export interface GetOrdersAvailableResult {
  items: OrderAvailableItem[];
  /** Cursor opaco para la siguiente página; null si no hay más. */
  lastKey?: string | null;
}

/** Fila de tabla para Reporte OS. */
export interface OrdersAvailableReportRow {
  orderId: string;
  numberOS: string | null;
  orderNumber: string | null;
  estadoOS: string | null;
  orderStatus: string | null;
  reservationNumber: string | null;
  reservationStatus: string | null;
  paymentCondition: string | null;
  fechaPago: string | null;
  paidAt: string | null;
  scheduledPaymentDate: string | null;
  currency: string | null;
  nameProveedor: string | null;
  numberFile: string | null;
  fileExtend: string | null;
  totalGeneral: number | null;
  baseAmount: number | null;
  commissionPercent: number | null;
  commissionAmount: number | null;
  lines: OrderAvailableLine[];
  serviceTypes: string[];
}

function orderBaseAmount(
  total?: number | null,
  commissionAmount?: number | null
): number | null {
  if (total == null) return null;
  if (commissionAmount == null) return total;
  return Math.round((total - commissionAmount) * 100) / 100;
}

export function mapOrderAvailableToReportRow(
  item: OrderAvailableItem
): OrdersAvailableReportRow {
  const lines = item.lines ?? [];
  const serviceTypes = [
    ...new Set(
      lines
        .map((line) => line.serviceSnapshot?.serviceType)
        .filter((value): value is string => Boolean(value))
    )
  ];

  return {
    orderId: item.orderId,
    numberOS: item.orderNumber ?? null,
    orderNumber: item.orderNumber ?? null,
    estadoOS: item.orderStatus ?? null,
    orderStatus: item.orderStatus ?? null,
    reservationNumber: item.reservationNumber ?? null,
    reservationStatus: item.reservationStatus ?? null,
    paymentCondition: item.paymentCondition ?? null,
    fechaPago: item.paidAt ?? null,
    paidAt: item.paidAt ?? null,
    scheduledPaymentDate: item.scheduledPaymentDate ?? null,
    currency: item.currency ?? null,
    nameProveedor: item.providerSnapshot?.name ?? null,
    numberFile: item.fileSnapshot?.fileNumber ?? null,
    fileExtend: item.fileSnapshot?.fileExtend ?? null,
    totalGeneral: item.total ?? null,
    baseAmount: orderBaseAmount(item.total, item.commissionAmount),
    commissionPercent: item.commissionPercent ?? null,
    commissionAmount: item.commissionAmount ?? null,
    lines,
    serviceTypes
  };
}
